/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoAppVersionUpdateRequest model module.
 * @module model/CampaignControllerDtoAppVersionUpdateRequest
 * @version 1.0
 */
class CampaignControllerDtoAppVersionUpdateRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoAppVersionUpdateRequest</code>.
     * @alias module:model/CampaignControllerDtoAppVersionUpdateRequest
     */
    constructor() { 
        
        CampaignControllerDtoAppVersionUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CampaignControllerDtoAppVersionUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoAppVersionUpdateRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoAppVersionUpdateRequest} The populated <code>CampaignControllerDtoAppVersionUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoAppVersionUpdateRequest();

            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoAppVersionUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoAppVersionUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['version'] && !(typeof data['version'] === 'string' || data['version'] instanceof String)) {
            throw new Error("Expected the field `version` to be a primitive type in the JSON string but got " + data['version']);
        }

        return true;
    }


}



/**
 * @member {String} version
 */
CampaignControllerDtoAppVersionUpdateRequest.prototype['version'] = undefined;






export default CampaignControllerDtoAppVersionUpdateRequest;

